import React, { useContext } from 'react';
import { useAllieAuth } from './useAllieAuth';
import { config } from '../helpers/configs';
import { UtilsContext } from '../context';

export const usePushNotifications = () => {
  const { loggedUser } = useAllieAuth();
  const { tracker } = useContext(UtilsContext);

  const checkPermission = () => {
    if (!('serviceWorker' in navigator)) {
      throw new Error("No support for service worker!");
    }

    if (!('Notification' in window)) {
      throw new Error("No support for notification API");
    }

    if (!('PushManager' in window)) {
      throw new Error("No support for Push API");
    }
  }

  const silentCheckPermission = async () => {
    let passed = true;

    if (!('serviceWorker' in navigator)) {
      tracker?.track('push_notifications', 'no_service_worker');
      passed = false;
    }

    if (!('Notification' in window)) {
      tracker?.track('push_notifications', 'no_notification_api');
      passed = false;
    }

    if (!('PushManager' in window)) {
      tracker?.track('push_notifications', 'no_push_api');
      passed = false;
    }

    if(passed) tracker?.track('push_notifications', 'ready');
  };

  const registerSW = async () => {
    let uuid = localStorage.getItem('uuid');
    if (!uuid) {
      uuid = crypto.randomUUID();
      localStorage.setItem('uuid', uuid);
    }
    const params = new URLSearchParams({
      api: config.API_BASE_URL.replace('/graphql', ''),
      key: config.PUSH_API_KEY,
      userId: String(loggedUser ? loggedUser.id : ''),
      uuid,
    });

    const registration = await navigator.serviceWorker.register(`push-sw.js?${params}`);

    return registration;
  }

  const requestNotificationPermission = async () => {
    const permission = await Notification.requestPermission();

    if (permission !== 'granted') {
        throw new Error("Notification permission not granted");
    }
  }

  const enablePN = async () => {
    checkPermission();
    await requestNotificationPermission();
    await registerSW();
  }

  return { enablePN, silentCheckPermission };
};
